import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const ENTITY: AppRouteRecordRaw = {
  path: '/entity',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '实体管理',
    requiresAuth: true,
    icon: 'icon-dashboard',
    order: 20
  },
  children: [
    {
      path: 'list',
      component: () => {
        return import('@/views/entity/list/page.vue');
      },
      meta: {
        locale: '实体列表',
        icon: 'icon-dashboard'
      }
    },
    {
      path: 'list/:parentId/:id',
      component: () => {
        return import('@/views/entity/list/page.vue');
      },
      meta: {
        locale: '实体列表',
        hideInMenu: true
      }
    },
    {
      path: 'edit/:topicOneId/:topicTwoId/:step/:id?',
      component: () => {
        return import('@/views/entity/edit/page.vue');
      },
      meta: {
        hideInMenu: true,
        locale: path => {
          return path.includes('add') ? '添加实体' : '编辑实体';
        }
      }
    }
  ]
};

export default ENTITY;
